<script setup>
import { ref } from 'vue';
import { trans } from '@elements/translation';
import { useOrganizationStore } from '../store/organization';
import TeamHeader from '../components/Organization/TeamHeader.vue';
import TeamMember from '../components/Organization/TeamMember.vue';
import InviteTeamMemberButton from '../components/Organization/Button/InviteTeamMemberButton.vue';
import InvitationModal from '../components/Organization/Modal/InvitationModal.vue';

const store = useOrganizationStore();
const data = window.initialAppState;

store.$patch({
  team: data.team,
  currentUserId: data.userId,
  invitations: data.invitations,
  accountManager: data.accountManager,
});

const { team, invitations } = store;
const modal = ref(null);
</script>

<template>
  <div>
    <h1 class="team-view-title">
      {{ trans('user_menu.team') }}
    </h1>
    <InvitationModal ref="modal" />
    <InviteTeamMemberButton @click="modal.openModal()" />
    <div class="team-view">
      <div class="team-list table">
        <TeamHeader />
        <TeamMember
          v-for="(user, index) in team"
          :key="`user-${user.id}`"
          :user="user"
          :index="index"
        />
        <TeamMember
          v-for="(user, index) in invitations"
          :key="`invitation-${user.id}`"
          is-invited
          :user="user"
          :index="index"
        />
      </div>
    </div>
  </div>
</template>
